import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import i18n from 'i18next'
import CircularProgress from '@material-ui/core/CircularProgress'
import FormHelperText from '@material-ui/core/FormHelperText'
import Button from '@material-ui/core/Button'
import FormGroup from '@material-ui/core/FormGroup'

import { validate, isDebug, renderField } from './helpers'
import productLineDefaults from '../../helpers/product-line-defaults'
import GetSignature from '../GetSignature'
import PropTypes from 'prop-types'
import { SignatureValidation } from '../../helpers/step-builder/validations-yup'

function SignatureFunc({
  payload,
  setPayload,
  prevStep,
  saveWaiver,
  waiverContent,
  productLine,
  obtainSignature,
  // eslint-disable-next-line react/prop-types
  waiverSignatureModel,
  t
}) {
  const [errors, setErrors] = useState({})
  const [submitting, setSubmitting] = useState(false)
  let signature
  const hd = {
    errors,
    payload,
    setPayload,
    t
  }

  setDebugPayload()
  const validation = SignatureValidation(waiverSignatureModel.safetyVideoRequired, obtainSignature, t)

  function findSafetyVideo() {
    // eslint-disable-next-line react/prop-types
    let video = waiverSignatureModel.safetyVideoUrl.initialValue
    if (video) {
      // YouTube videos need to be embedded syntax
      // eslint-disable-next-line react/prop-types
      return video.replace('/watch?v=', '/embed/')
    }
    return productLineDefaults.SafetyVideos[productLine]
  }

  function completedClick() {
    setPayload({
      ...payload,
      signatureIsNotEmpty: payload.isSignatureRequired ? !signature.isEmpty() : false,
      finished: true
    })
  }

  const buttonFunctions = { completedClick, prevStep }

  useEffect(() => {
    if (payload.finished) {
      validate(validation, payload)
        .then(async (_errors) => {
          if (Object.keys(_errors).length === 0) {
            let sign
            if (obtainSignature) {
              sign = await signature.toJpeg()
            }
            setSubmitting(true)
            saveWaiver(sign)
          }
          setErrors(_errors)
        })
        .then(() => {
          setPayload({ ...payload, finished: false })
        })
        .catch((err) => {
          console.log('validation error', err)
          setSubmitting(false)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payload.finished])

  useEffect(() => {
    setPayload({ isSafetyVideoRequired: !!waiverContent.safetyVideoUrl, isSignatureRequired: obtainSignature })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [waiverContent.safetyVideoUrl, obtainSignature])

  return (
    <>
      {submitting ? (
        <div className="center">
          <CircularProgress />
        </div>
      ) : (
        <>
          {payload.isSafetyVideoRequired && (
            <>
              <div className="aspect-ratio">
                <iframe
                  title="safety video"
                  width="560"
                  height="315"
                  src={findSafetyVideo()}
                  frameBorder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </>
          )}

          <FormGroup>
            {payload.isSafetyVideoRequired && (
              <>{renderField(hd, waiverSignatureModel.safetyVideoRequired, waiverContent)}</>
            )}
            {obtainSignature && <GetSignature signature={t('signature')} ref={(ref) => (signature = ref)} />}
            {errors.signatureIsNotEmpty && <FormHelperText error>{errors.signatureIsNotEmpty}</FormHelperText>}
          </FormGroup>
          <div className="right">
            {waiverSignatureModel &&
              // eslint-disable-next-line react/prop-types
              waiverSignatureModel.buttons.map((button, ix) => (
                <Button
                  variant={button.variant}
                  color={button.color}
                  size={button.size}
                  className={button.className}
                  onClick={buttonFunctions[button.clickFunc]}
                  id={
                    // eslint-disable-next-line react/prop-types
                    waiverSignatureModel.label + '-' + button.label + '-' + ix.toString()
                  }
                  key={
                    // eslint-disable-next-line react/prop-types
                    waiverSignatureModel.label + '-' + button.label + '-' + ix.toString()
                  }
                >
                  {t(button.label)}
                </Button>
              ))}
          </div>
        </>
      )}
    </>
  )

  function setDebugPayload() {
    if (isDebug() && Object.keys(payload).length < 2) {
      setPayload({
        safetyVideoRequired: true,
        signatureRequired: true
      })
    }
  }
}

export const Signature = withTranslation()(SignatureFunc)

SignatureFunc.propTypes = {
  payload: PropTypes.object.isRequired,
  setPayload: PropTypes.func.isRequired,
  prevStep: PropTypes.func.isRequired,
  saveWaiver: PropTypes.func.isRequired,
  waiverContent: PropTypes.object.isRequired,
  productLine: PropTypes.string.isRequired,
  obtainSignature: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  waiverSignatureModel: PropTypes.object.isRequired
}
